<template lang="pug">
.members
  .seats-increase-warning-box.dialog-warning.blue.align-items-center(v-if="organization.show_per_seat_ui")
    i.d-flex.align-items-center.hi.hi-info-filled.hi-12.text-blue.pt-0

    div
      | Moving Project viewers to Users or Managers will move them from a free seat to a paid seat, and may increase the number of paid seats on your plan.&nbsp;
      a.text-nowrap(href="https://support.hubstaff.com/per-seat-pricing/")
        | Learn more

  #manager.form-group
    AppLazySelect(
      ref="manager-selector"
      v-model="manager"
      eager
      multiple
      append-to-body
      label="Managers"
      title="Select managers"
      resource="member"
      :unclearable-ids="selectedDisabledIds"
      :fetcher="fetcher"
      :disabled="disabled"
      :organization-id="organizationId"
      :resource-id="projectId"
      :disabled-tooltip="disabledTooltip"
      description="Oversees and manages the project"
      @input="submitSelections($event, 'manager')"
    )
      template(#item-leading="{ item }")
        AppAvatar(
          v-if="item.avatar"
          :avatar="item.avatar"
          size="speck"
        )

  #user.form-group
    AppLazySelect(
      ref="user-selector"
      v-model="user"
      eager
      multiple
      append-to-body
      label="Users"
      title="Select users"
      resource="member"
      :unclearable-ids="selectedDisabledIds"
      :fetcher="fetcher"
      :disabled="disabled"
      :organization-id="organizationId"
      :resource-id="projectId"
      disabled-tooltip="disabledTooltip"
      description="Works on the project, will not see other users (most common)"
      @input="submitSelections($event, 'user')"
    )
      template(#item-leading="{ item }")
        AppAvatar(
          v-if="item.avatar"
          :avatar="item.avatar"
          size="speck"
        )
      template(#after-label)
        i.hi.hi-info-filled.hi-12.a-tooltip(
          v-tooltip
          title="Users who have member limits set within this project will not be removed."
        )

  #viewer.form-group
    AppLazySelect(
      ref="viewer-selector"
      v-model="viewer"
      eager
      multiple
      append-to-body
      label="Viewers"
      title="Select viewers"
      resource="member"
      :unclearable-ids="selectedDisabledIds"
      :fetcher="fetcher"
      :disabled="disabled"
      :organization-id="organizationId"
      :resource-id="projectId"
      :disabled-tooltip="disabledTooltip"
      description="Can view team reports for this project"
      @input="submitSelections($event, 'viewer')"
    )
      template(#item-leading="{ item }")
        AppAvatar(
          v-if="item.avatar"
          :avatar="item.avatar"
          size="speck"
        )
</template>

<script>
import { ProjectsResource } from '~/resources';
import { mapState, mapActions } from 'vuex';
import { MEMBER_ROLES } from '../../app_constants';

export default {
  name: 'ProjectDialogTabMembers',
  computed: {
    ...mapState({
      project: (state) => state.project,
      allMembers: (state) => ({ ...state.membersMap }),
      organization: (state) => state.organization,
      disabled: (state) => !state.organization.features.manager_roles.available,
      disabledTooltip: (state) => state.organization.restricted_tooltip,
      selectedDisabledIds: (state) => state.project.team_member_ids || [],
    }),
    projectId() {
      return this.project?.id || null;
    },
    organizationId() {
      return this.organization.id;
    },
    resource() {
      return ProjectsResource.members;
    },

    ...Object.fromEntries(
      ['manager', 'user', 'viewer'].map((role) => [
        role,
        {
          get() {
            return [...this.allMembers[role].values()];
          },
          set(items) {
            this.updateMembers({ items, role });
          },
        },
      ]),
    ),
  },
  methods: {
    ...mapActions(['updateProject', 'updateMembers']),
    fetcher(payload) {
      return ProjectsResource.members({ organization_id: this.organizationId }, {...payload, ...(this.project.id ? {} : { restricted_lead_members: true })}, {
        abortReload: true,
      });
    },
    async submitSelections(items = [], role = 'user') {
      // We only want to actually remove the items with the `selected: true` set
      Object.values(MEMBER_ROLES)
        .filter((r) => r !== role)
        .map((role) => this.$refs[`${role}-selector`].excludeItems(items))
        .filter(Boolean);
    },
  },
};
</script>
